export const mintTypes = {
    setPrices: '[Mint] sets mint prices for all options',
    setUSD: '[Mint] sets USD parity',
    setStep1: '[Mint] sets the selected option for step 1',
    setStep2: '[Mint] sets the selected option for step 2',
    setTerms: '[Mint] sets the terms and conditions as selected',
    setTotal: '[Mint] sets the total cost in eth',
}